import React, { FC } from 'react';
import { Error } from 'components';
import { Card, Note } from 'components/ui';
import { Field } from 'react-final-form';
import { SelectTagsWrapper, TextInputWrapper } from 'components/forms';
import { useQuery } from '@redux-requests/react';
import { AppsConstants } from 'modules/userApps/store/constants';
import { t } from 'utils';

const validateAppName = (value = ''): any =>
  value.trim().length <= 64 ? undefined : 'invalidLength';
// TODO: either extract this error type to a separate component or figure out how to use already created error component by figuring out how to pass to isError a boolean for a single field and not the whole form
const FormattedError = ({ name = '' }): any => (
  <Field name={name} subscription={{ error: true }}>
    {({ meta: { error } }) =>
      error ? (
        <Error className='mb-1' isError>
          {t('form.step.app.details.name.error')}
        </Error>
      ) : null
    }
  </Field>
);

const AppDetails: FC<{ submitError: any; modifiedSinceLastSubmit: boolean }> = ({
  submitError,
  modifiedSinceLastSubmit,
}) => {
  const { data } = useQuery({ type: AppsConstants.APP_CATEGORIES });

  return (
    <Card title='form.step.app.details.title'>
      <Field
        label='form.step.app.details.app.label'
        placeholder='form.step.app.details.app.placeholder'
        name='name'
        component={TextInputWrapper}
        className='mb-1'
        required
        initialValue=''
        validate={validateAppName}
      />
      <FormattedError name='name' />
      <Note className='mb-2'>{t('form.step.app.details.name.note')}</Note>
      <Field
        name='categories'
        component={SelectTagsWrapper}
        placeholder='form.step.app.details.app.category.placeholder'
        options={data}
        className='mb-1'
        isFullWidthTags
        tagsLimitHeight={90}
      />
      <Note>{t('form.step.app.details.categories.note')}</Note>
      <Error
        apiError={submitError}
        defaultError='errors.somethingWentWrong'
        className='mt-2'
        isError={submitError && !modifiedSinceLastSubmit}
      />
    </Card>
  );
};

export default AppDetails;
